import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import InstitutionIconsLinkOrAddAccountsContent from 'Components/ComponentLibrary/Organisms/LinkOrAddAccounts/InstitutionIcons/LinkOrAddAccountsContent';
import classNames from 'classnames';
import {
  useWizardStepWrapperTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate/useWizardStepWrapperTemplate';
import { StepNavigatorWrapper } from 'Components/ComponentLibrary/Molecules/StepNavigator/StepNavigatorWrapper';
import PreviousButton from 'Components/ComponentLibrary/Atoms/Inputs/PreviousButton';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import AggregatorButtonPicker from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/AggregatorButtonPicker';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('InstitutionIconsLinkOrAddAccountsTemplate', (theme) => ({
  // Below drawer, above top nav
  sideBarZIndex: {
    zIndex: theme.zIndex.sideBar,
  },
  continueBtn: {
    display: 'flex',
    flex: 1,
  },
}));

const InstitutionIconsLinkOrAddAccountsTemplate = ({
  resource,
  className,
}) => {
  const classes = useStyles();
  const { loadPageContentLink } = usePageContentContext();
  const {
    classes: wizardStepWrapperClasses,
    onPrevious,
    header,
  } = useWizardStepWrapperTemplate({ resource });

  return (
    <div
      className={classNames(className, classes.root, wizardStepWrapperClasses.root)}

      {...dataAttrs('wizard-step', resource)}
    >
      {header}
      <InstitutionIconsLinkOrAddAccountsContent
        resource={resource}
        onLoadLink={loadPageContentLink}
        classes={classes}
        className={className}
      />
      <div className={classNames(wizardStepWrapperClasses.navigation, classes.sideBarZIndex)}>
        <StepNavigatorWrapper className={classes.sideBarZIndex}>
          {onPrevious && <PreviousButton test="prev-step" onClick={onPrevious} />}
          <AggregatorButtonPicker
            resource={resource}
            onLoadLink={loadPageContentLink}
            renderButtonComponentChildren={() => 'Continue'}
            classes={{ root: classes.continueBtn }}
            ButtonComponent={RoundedButton}
            ButtonComponentProps={{
              variant: 'contained',
              color: 'primary',
              fullWidth: true,
              size: 'sm',
              'data-test': 'link-institution-button',
            }}
          />
        </StepNavigatorWrapper>
      </div>
    </div>
  );
};

InstitutionIconsLinkOrAddAccountsTemplate.defaultProps = {
  className: '',
};

InstitutionIconsLinkOrAddAccountsTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default InstitutionIconsLinkOrAddAccountsTemplate;
